export default function CtaSection() {
  return (
    <section
      id="iletisim"
      className="relative py-28 px-6 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="/images/cta.jpg"
          alt="CTA Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A2B4A]/85 via-[#1A2B4A]/70 to-[#1A2B4A]/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <span className="inline-block text-[#4CAF50] text-sm font-semibold uppercase tracking-widest mb-4">
          Hemen Başlayalım
        </span>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
          Projeniz mi Var?
        </h2>
        <p className="text-white/75 text-lg mb-10 max-w-xl mx-auto">
          Bizimle iletişime geçin, ücretsiz keşif ve teklif alın. Uzman ekibimiz en kısa sürede size ulaşsın.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://wa.me/905321367981"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2.5 bg-[#25D366] text-white font-semibold px-8 py-4 rounded-full hover:bg-[#1ebe5d] transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-whatsapp-line text-lg" />
            WhatsApp ile Yaz
          </a>
          <a
            href="tel:+905321367981"
            className="flex items-center justify-center gap-2.5 bg-white text-[#1A2B4A] font-semibold px-8 py-4 rounded-full hover:bg-[#F8F9FA] transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-phone-line text-lg" />
            Hemen Ara
          </a>
        </div>
      </div>
    </section>
  );
}
